module.exports = __webpack_public_path__ + "static/media/8.b27c7473.jpg";